import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material';
import * as _ from 'lodash';
import { Edits } from '../../../shared/models/common';
import { LinguistService } from '../../../shared/services/linguist.service';
import { IComparisonEnrichedNode } from 'json-diff-ts';

@Component({
  selector: 'app-diff',
  templateUrl: './diff.component.html',
  styleUrls: ['./diff.component.less']
})
export class DiffComponent implements OnInit {
  private _diffString: string = '';
  public parsedDiff: any = null;

  @Input()
  set diff(value: string) {
    this._diffString = value;
    this.parseJson(value);
  }

  get diff() {
    return this.parsedDiff;
  }

  private parseJson(value: string) {
    try {
      this.parsedDiff = JSON.parse(value);
    } catch (error) {
      this.parsedDiff = value;
    }
  }
  


  constructor(private linguisticsService: LinguistService) {
  }

  ngOnInit() {
    // if (this.tableName && this.entityId) {
    //   this.linguisticsService.getAuditTrail(this.tableName, this.entityId).then(edits => {
    //     this.editLog = edits;
    //     for (let editEntry of this.editLog) {
    //       try {
    //         if (editEntry.diff && typeof editEntry.diff == 'string') {
    //           editEntry.diff = JSON.parse(editEntry.diff);
    //         }
    //         if (editEntry.original)
    //           editEntry.parsedOriginal = this.removeFields(JSON.parse(this.removeWrongEscape(editEntry.original)));

    //         if (editEntry.requestBody) {
    //           let newVersion = this.removeFields(JSON.parse(this.removeWrongEscape(editEntry.requestBody)));
    //           editEntry.parsedRequestBody = newVersion;
    //         }
    //       } catch (error) {
    //         editEntry.parseError = error;
    //         console.error("Cannot parse body: " + error);
    //       }
    //     }
    //   });
    // }
  }

  isObject(obj: any): boolean {
    return _.isObject(obj);
  }
  
  isArray(input: any): boolean {
    return _.isArray(input);
  }

  isString(value: any): boolean {
    return typeof value === 'string';
  }

  splitExample(value: string): string[] {
    if (!value) return [];
    return value.split('\n').filter(line => line.trim());
  }

  hasSpecialProperties(obj: any): boolean {
    if (!obj || !this.isObject(obj)) return false;
    return ['added', 'removed', 'modified', 'from', 'to'].some(prop => prop in obj);
  }

  omitIdentity(obj: any): any {
    if (!obj || !this.isObject(obj)) return obj;
    return _.omit(obj, ['identity']);
  }

  getChangeClass(type: string): string {
    switch (type) {
      case 'added':
        return 'diff-added';
      case 'removed':
        return 'diff-removed';
      case 'modified':
        return 'diff-modified';
      default:
        return '';
    }
  }

  safeJson(value: string): any {
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (error) {
      return value;
    }
  }
}
